import { render, staticRenderFns } from "./BigTitleColor.vue?vue&type=template&id=6d2a97dd&"
import script from "./BigTitleColor.vue?vue&type=script&lang=js&"
export * from "./BigTitleColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports